import { render, staticRenderFns } from "./AlertForm.vue?vue&type=template&id=bc1e49d8&"
import script from "./AlertForm.vue?vue&type=script&lang=js&"
export * from "./AlertForm.vue?vue&type=script&lang=js&"
import style0 from "./AlertForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports